import { ConfigurationType } from 'data/types';

export function buildConfigurationSelectionSignature(
  configurations: ConfigurationType[]
): string {
  return configurations
    .map((config) => config.uniqueId)
    .sort()
    .join('|');
}

export function selectedConfigIdsToFilterValue(
  selectedConfigIds: string[],
  allConfigIds: string[]
): string[] | null {
  if (selectedConfigIds.length === 0) {
    return null;
  }
  if (selectedConfigIds.length === allConfigIds.length) {
    return null;
  }
  return selectedConfigIds;
}
